import { useEffect, useState } from 'react';
import { setFullDropZone } from '../../Store/layoutSlice';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../Store/store';
import * as React from 'react';
import { useAuthorize } from './useAuthorize';
import { setTaxNumber, setTransactionViewerFilter } from '../../Store/paramsBagSlice';
import { BookedState } from '../Transaction/Filter/BookedState';
import { Spinner } from '../Layout/Spinner';

const standardiseAccountNumber = (accountNumber?: string): string | null => {
  if (!accountNumber) {
    return null;
  }

  if (/^[a-zA-Z]{2}/.test(accountNumber)) {
    accountNumber = accountNumber?.substring(4);
  }
  return accountNumber?.replace(/\D/g, '');
};
export const AuthenticateRoute = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const [to, setTo] = useState('');
  const searchParams = new URLSearchParams(location.search);
  const accountNr = searchParams.get('accountNr');
  const originate = searchParams.get('originate');
  const bookingDate = searchParams.get('bookingDate');
  const partnerName = searchParams.get('partnerName');
  const partnerTaxId = searchParams.get('partnerTaxId');
  const amount = searchParams.get('amount');
  const currency = searchParams.get('currency');
  const description = searchParams.get('description');

  const dispatch = useAppDispatch();

  const { authorize, isLoading } = useAuthorize(params.token);

  useEffect(
    () => {
      const splitUrl = location?.pathname?.split('/');
      const index = params?.taxNumber ? -2 : -1;
      const originalUrl = splitUrl.slice(0, index).join('/');
      setTo(() => (originalUrl === '/registration/confirm' ? '/confirm' : originalUrl));
      if (params?.taxNumber) {
        const taxNumber = params?.taxNumber?.length > 8 ? params?.taxNumber?.substring(0, 8) : params?.taxNumber;
        dispatch(setTaxNumber(taxNumber));

        if (accountNr || originate || bookingDate || partnerName || partnerTaxId || amount || description || currency) {
          dispatch(
            setTransactionViewerFilter({
              accountNr: accountNr ? standardiseAccountNumber(accountNr) : null,
              // originate: originate,
              bookingDate: bookingDate,
              partnerName: partnerName,
              partnerTaxId: partnerTaxId,
              amount: amount,
              currency: currency,
              description: description,
              booked: BookedState.UNBOOKED,
            })
          );
        }
      }

      dispatch(setFullDropZone(splitUrl.includes('bankaccounts')));
      (async () => {
        await authorize();
      })();
    }, // eslint-disable-next-line
    [
      dispatch,
      location?.pathname,
      navigate,
      params.token,
      authorize,
      params?.taxNumber,
      params?.accountNr,
      params?.originate,
      params?.bookingDate,
      accountNr,
      originate,
      bookingDate,
      isLoading,
    ]
  );

  if (isLoading) {
    return <Spinner />;
  }

  return <Navigate to={to} replace />;
};
